// // components/TurnstileWidget.tsx
import React, { useEffect, useRef } from "react";
import Config from "./../../Config";

declare global {
  interface Window {
    turnstile: any;
  }
}

type TurnstileProps = {
  onSuccess: (token: string) => void;
};

const TurnstileWidget: React.FC<TurnstileProps> = ({ onSuccess }) => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const turnstileIdRef = useRef<string | null>(null);
  const isRenderedRef = useRef<boolean>(false);

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.turnstile &&
      widgetRef.current &&
      !isRenderedRef.current
    ) {
      turnstileIdRef.current = window.turnstile.render(widgetRef.current, {
        sitekey: Config.CLOUDFLARE_SITE_KEY,
        callback: onSuccess,
        theme: "light", // optional (dark or light)
        "error-callback": () => {
        },
      });

      isRenderedRef.current = true;
    }
  }, [onSuccess]);
  
  return <div ref={widgetRef} />;
};

export default TurnstileWidget;